document.addEventListener('click', function (e) {
    if (!e.target.closest('#btnEliminarAlmacenadoDesdEditar')) return;

    const idAlmacenado = document.getElementById('idLineaEntregaPaquetesAlmacenadosEditar').value;
    const idReporte    = document.getElementById('idReporteSopladoEditarAlmacenado').value;

    const inputIdEliminar      = document.getElementById('idLineaEntregaPaquetesAlmacenadosEliminar');
    const inputReporteEliminar = document.getElementById('idReporteSopladoEliminarAlmacenado');

    if (inputIdEliminar)      inputIdEliminar.value      = idAlmacenado ?? '';
    if (inputReporteEliminar) inputReporteEliminar.value = idReporte    ?? '';
});

document.addEventListener('submit', function (e) {
    const form = e.target.closest('#formEliminarAlmacenadoSoplado');
    if (!form) return;
    e.preventDefault();

    modal = form.closest('.modal');
    modalEditar = document.querySelector('#modalEditarAlmacenadoSoplado');

    const btnSubmit = form.querySelector('[type="submit"]');
    if (btnSubmit) btnSubmit.disabled = true;

    const data = new FormData(form);

    fetch('/api/soplado/eliminar-entrega-almacenado', {
        method: 'POST',
        credentials: 'include',
        body: data
    })
    .then(r => r.json())
    .then(json => {
        const errores = json.result.errores ?? [];
        errores.forEach(e => lanzarAlerta(e.mensaje, e.clase));

        if (!json.result.hayErrores) {
            const idReporte = document.getElementById('idReporteSopladoEliminarAlmacenado').value;
            form.reset();
            modal.classList.remove('modal--show');
            modalEditar.classList.remove('modal--show');
            if (idReporte && typeof window.actualizarTablaAlmacenado === 'function') {
                window.actualizarTablaAlmacenado(idReporte);
            }
            if (typeof window.actualizarModalReporteSoplado === 'function') {
                window.actualizarModalReporteSoplado(idReporte);
            }
            lanzarAlerta('Entrega almacenada eliminada correctamente.', 'alerta-verde');
        }
    })
    .catch(() => lanzarAlerta('Error al conectar con el servidor.', 'alerta-roja'))
    .finally(() => { if (btnSubmit) btnSubmit.disabled = false; });
});
